import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@sm/wds-react';
import { createSurveyStyles } from '@sm/webassets';
import { PageVariants, EnterpriseThankYouContext } from '~app/pages/EnterpriseThankYou';

const useStyles = createSurveyStyles(theme => {
  return {
    background: {
      background: theme?.primaryBackgroundColor,
    },
  };
});

const BackgroundThemeWrapper = ({ children }) => {
  const { pageVariant } = useContext(EnterpriseThankYouContext);
  const premiumCustom = pageVariant === PageVariants.premiumCustom;

  const { background } = useStyles();
  return <Container className={`background-wrapper ${premiumCustom ? background : ''}`}>{children}</Container>;
};

BackgroundThemeWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BackgroundThemeWrapper;
